export const ADD_APPROVER_REQUEST = "ADD_APPROVER_REQUEST";
export const ADD_APPROVER_SUCCESS = "ADD_APPROVER_SUCCESS";
export const ADD_APPROVER_FAILURE = "ADD_APPROVER_FAILURE";
export const ADD_APPROVER_RESET = "ADD_APPROVER_RESET";
export const addApproverRequest = (payload) => ({
    type: ADD_APPROVER_REQUEST,
    payload,
});
export const addApproverSuccess = (payload) => ({
    type: ADD_APPROVER_SUCCESS,
    payload,
});
export const addApproverFailure = (payload) => ({
    type: ADD_APPROVER_FAILURE,
    payload,
});
export const addApproverReset = () => ({
    type: ADD_APPROVER_RESET,
});
